enum StartSessionStatusCode {
  successed = 200,
  notAuthorized = 401,
}

export default StartSessionStatusCode;
